export default "__VITE_ASSET__D3VhxP4E__"